export enum RowDensity {
  NORMAL = 36,
  SMALL = 30,
  EXTRA_SMALL = 24,
}
